import React, { useEffect, useCallback, useState, useMemo, useRef } from 'react';
import ReactQuill, { Quill } from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';
import QuillTableBetter from "quill-table-better";
import "quill-table-better/dist/quill-table-better.css";

Quill.register({ "modules/table-better": QuillTableBetter }, true);

type QuillEditorProps = {
  htmlContent: string;
  setHtmlContent: (htmlContent: string) => void;
}

const Write = ({ htmlContent, setHtmlContent }: QuillEditorProps) => {
 
  const quillRef = useRef<ReactQuill>(null);

 /* const handleChange = (value) => {
    setContent(value);
  };*/

  useEffect(() => {
  const isLoggedIn = sessionStorage.getItem('loggedIn') === 'true';
  if (!isLoggedIn) {
    window.location.href = '/login';
  }
}, []);

 useEffect(() => {
    if (quillRef.current) initValue();
  }, [quillRef]);


  const modules = useMemo(
        () => ({
            toolbar: { // 툴바에 넣을 기능
                container: [
                    [{ header: 1 }, { header: 2 }],
                    ["bold", "italic", "underline", "strike", "blockquote"],
                    [{ size: ["small", false, "large", "huge"] }, { color: [] }],
                    [
                        { list: "ordered" },
                        { list: "bullet" },
                        { indent: "-1" },
                        { indent: "+1" },
                        { align: [] },
                        { color: [] },
                        { background: [] }
                    ],
                    ["table-better"], // Add table tool
        ],
      },
      table: false,
      "table-better": {
        language: "en_US",
        menus: [
          "column",
          "row",
          "merge",
          "table",
          "cell",
          "wrap",
          "copy",
          "delete",
        ],
        toolbarTable: true,
      },
      keyboard: {
        bindings: QuillTableBetter.keyboardBindings,
      },
    }),
    []
  );

  function initValue() {
    const html = `
    <table style="width: 216px" class="ql-table-better">
    <tbody>
      <tr>
        <td data-row="row-kbbt" width="72" class="">
          <p class="ql-table-block" data-cell="cell-pqbh">1</p>
        </td>
        <td data-row="row-kbbt" width="72" style="background-color: #4d99e6; " class="">
          <p class="ql-table-block" data-cell="cell-6vwb">2</p>
        </td>
        <td data-row="row-kbbt" width="72" style="background-color: #4d99e6; " class="">
          <p class="ql-table-block" data-cell="cell-sbdd">3</p>
        </td>
      </tr>
      <tr>
        <td data-row="row-j9rd" width="72" class="">
          <p class="ql-table-block" data-cell="cell-hbqz">4</p>
        </td>
        <td data-row="row-j9rd" width="72" class="">
          <p class="ql-table-block" data-cell="cell-kgtt">5</p>
        </td>
        <td data-row="row-j9rd" width="72" class="">
          <p class="ql-table-block" data-cell="cell-2pu4">6</p>
        </td>
      </tr>
      <tr>
        <td data-row="row-inie" width="72" class="">
          <p class="ql-table-block" data-cell="cell-x6xx">7</p>
        </td>
        <td data-row="row-inie" width="72" class="">
          <p class="ql-table-block ql-align-center" data-cell="cell-8axw">8</p>
        </td>
        <td data-row="row-inie" width="72" class="">
          <p class="ql-table-block ql-align-center" data-cell="cell-45td">9</p>
        </td>
      </tr>
    </tbody>
  </table>
    `;
    if (quillRef.current) {
    const editor = quillRef.current.getEditor();
    const delta = editor.clipboard.convert({ html });
    const [range] = editor.selection.getRange();
    editor.updateContents(delta, Quill.sources.USER);
    
    editor.setSelection(
      delta.length() - (range?.length || 0),
      Quill.sources.SILENT
    );
    editor.scrollSelectionIntoView();
  }
  }

  return (
    <div>
        <div className='title-box'>
          <h1 className='maintitle'>게시글 작성</h1>
        </div>
      <form method='post' action='/api/send-post'>
        <div className='post-title'>
            <select name='post-selector' className='post-selector'>
                <option value={'notice'}>공지</option>
                <option value={'contents'}>콘텐츠</option>
                <option value={'patch'}>패치노트</option>
            </select>
            <textarea
            name='post-title'
            rows={1}
            cols={50}
            placeholder="여기에 제목을 입력하세요."
            className='post-content-title'
            />
        </div>
        <div className='editor' id='editor'>
          <ReactQuill 
          ref={(element) => {
            if (element !== null) {
              quillRef.current = element;
            }
          }}
          
          theme="snow"
          value={htmlContent}
          modules={modules}
          onChange={setHtmlContent}
          />
        </div>
        <input type="hidden" name="post-content" value={htmlContent} />
        <div className='post-send-box'>
        <button className='del' id='del'>취소</button>
        <button className='submit' type='submit'>글 쓰기</button>
        </div>
        </form>
        <footer className='writer-ver'>
          Version 0.4 β
        </footer>
    </div>
  )
}


export default Write;